import Labels from '@/constants/ui/Labels';

const WorkPhoneLabels = [Labels.OFFICE, Labels.MOBILE, Labels.FAX];

export default WorkPhoneLabels;
